import React, { useState, useEffect } from 'react';
import { BringzzIcon, BringzzText } from '@bringzz/components';
import { useAuth } from 'context/AuthContext';
import { useNavigation } from 'context/NavigationContext';
import { USER_ROLES } from 'utils/constants';
import classNames from 'classnames';

const ShopperAvailabilityOverlay = () => {
    const { user } = useAuth();
    const { isActive } = useNavigation();
    const [isAvailable, setIsAvailable] = useState(false);

    useEffect(() => {
        // Load initial state from localStorage
        const savedState = localStorage.getItem('shopperAvailability');
        setIsAvailable(savedState === 'true');
    }, []);

    const toggleAvailability = () => {
        const newState = !isAvailable;
        setIsAvailable(newState);
        localStorage.setItem('shopperAvailability', String(newState));
    };

    // Only render for shoppers and only on homepage forn now
    if (
        !user ||
        user.userRole !== USER_ROLES.SHOPPER_ROLE ||
        !isActive('/home')
    ) {
        return null;
    }

    return (
        <div className="fixed top-14 right-4 z-50">
            <button
                onClick={toggleAvailability}
                className={classNames(
                    'bg-magic-lilac rounded-full shadow-lg transition-all duration-300 transform hover:scale-105',
                    'flex items-center space-x-2 px-4 py-2.5'
                )}
            >
                <BringzzIcon
                    size="18"
                    icon={isAvailable ? "IconPause" : "IconPlay"}
                    folder="LineIcons"
                    className="text-white"
                />
                <BringzzText tag="span" className="text-white font-medium text-sm">
                    {isAvailable ? 'Pause' : 'Continue'}
                </BringzzText>
            </button>
        </div>
    );
};

export default ShopperAvailabilityOverlay; 